<script setup lang="ts">
import {Swiper} from "swiper";
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import {examPreview} from "~/apis/data";

const allItems = ref([])
const categoryExpanded = ref<{ [key: string]: boolean }>({});
const currentItem = ref(1)
const currentPreviewImages = ref<any[]>([]);
const dataLayerPopup = useDataLayerPopup()

const swiperContainer = ref<HTMLElement>()
let swiperInstance: any = null


// 전체 데이터에서 리스트 요소별 고유 index 추가
const processedItems = computed(() => {
  console.log('processedItems')
  let sequentialIndex = 1; // 1부터 시작하는 인덱스

  return allItems.value.map(category => ({
    ...category,
    SUB_ARR: category.SUB_ARR.map(subItem => ({
      ...subItem,
      sequentialId: sequentialIndex++
    }))
  }));
});


// 카테고리 토글 핸들러
const handleCategoryToggle = (categoryId: string) => {
  categoryExpanded.value[categoryId] = !categoryExpanded.value[categoryId];
};
// 리스트 요소 선택
const handleItemSelect = (item: any, index: number) => {
  currentItem.value = index
  currentPreviewImages.value = item.PREVIEW_ARR
}

// 목록 조회
const getExamPreview = async () => {
  try {
    const res = await examPreview()
    if (res.data.code === '200') {
      const items = res.data.data
      allItems.value = items

      if (dataLayerPopup.state.value.dataPreview.data.category_id) {
        // 맞춤 자료 > 선택된 값에 대한 값으로 선택 처리
        const categoryId = dataLayerPopup.state.value.dataPreview.data.category_id
        const subId = dataLayerPopup.state.value.dataPreview.data.sub_id
        const subArr = processedItems.value.find(item => item.CATEGORY_ID === dataLayerPopup.state.value.dataPreview.data.category_id).SUB_ARR.find(sub => sub.SUB_ID === subId)

        categoryExpanded.value[categoryId] = true
        currentPreviewImages.value = subArr.PREVIEW_ARR
        currentItem.value = subArr.sequentialId

      } else {
        // 메인 랜딩 > 첫번째 값 자동 선택 처리
        allItems.value.forEach(item => {
          categoryExpanded.value[item.CATEGORY_ID] = true
        })
        // categoryExpanded.value[allItems.value[0].CATEGORY_ID] = true
        currentPreviewImages.value = allItems.value[0].SUB_ARR[0].PREVIEW_ARR
      }
    }
  } catch (err) {
    console.log('[ERROR] 조회 오류 - ', err)
  }
}

const initSwiper = async () => {

  swiperInstance = new Swiper('.previewSwiper', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    slideNextClass: 'btnDataPreviewNext',
    slidePrevClass: 'btnDataPreviewPrev',
    navigation: {
      nextEl: '.btnDataPreviewNext',
      prevEl: '.btnDataPreviewPrev',
    },
  })
}

const handleCloseLayer = () => {
  dataLayerPopup.hideDataPreview()
}

const handleSwiperPrevClick = () => {
  if (swiperInstance) {
    swiperInstance.slidePrev()
  }
}

const handleSwiperNextClick = () => {
  if (swiperInstance) {
    swiperInstance.slideNext()
  }
}

onMounted(() => {
  getExamPreview()
})
onUpdated(() => {
  if (!swiperInstance) {
    initSwiper()
  }
})

onUnmounted(() => {
  if (swiperInstance) {
    swiperInstance.destroy()
  }
})
// 프리뷰 이미지가 변경될 때마다 Swiper 재초기화
watch(currentPreviewImages, () => {
  nextTick(() => {
    if (swiperInstance) {
      swiperInstance.destroy()
    }
    initSwiper()
  })
})

</script>
<template>
  <div class="layer active">
    <div class="mask" @click="handleCloseLayer"></div>
    <div class="inner">
      <section class="dataPreview fullHeight">
        <header class="bdb">
          <h2>자료 미리보기</h2>
          <a class="layerClose" @click="handleCloseLayer">닫기</a>
        </header>
        <main>
          <aside>
            <ul>
              <li v-for="item in processedItems" :key="item.CATEGORY_ID">
                <a
                  :class="{ toggleActive: categoryExpanded[item.CATEGORY_ID] }"
                  @click="handleCategoryToggle(item.CATEGORY_ID)"
                >
                  {{ item.CATEGORY_NM }}
                </a>
                <ul v-show="categoryExpanded[item.CATEGORY_ID]">
                  <li v-for="subItem in item.SUB_ARR" :key="subItem.sequentialId">
                    <a
                      :class="{
                        active: currentItem === subItem.sequentialId
                      }"
                      @click="handleItemSelect(subItem, subItem.sequentialId)"
                    >
                      {{ subItem.SUB_NM }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </aside>
          <div class="preview">
            <div class="swiper previewSwiper" ref="swiperContainer">
              <div class="swiper-wrapper">
                <div
                  v-for="(image, index) in currentPreviewImages"
                  :key="index"
                  class="swiper-slide img"
                >
                  <!--img size 452 * 640-->
                  <img :src="image.PREVIEW_URL" alt="이미지 미리보기" />
                </div>
              </div>
              <div class="btnNav btnDataPreviewPrev"></div>
              <div class="btnNav btnDataPreviewNext"></div>
            </div>
          </div>
        </main>
      </section>
    </div>
  </div>
</template>
